import TKCarousel from '@tk/components/tk.carousel';

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

import deepMerge from '@tk/utilities/tk.deep.merge';

export default class KWCarousel extends TKCarousel {
    constructor() {
        super();
    }

    mountCarousel(): void {
        const root = this.querySelector<HTMLElement>('[data-tk-carousel-root]');
        const prevButton = this.querySelector<HTMLElement>('[data-tk-carousel-prev]');
        const nextButton = this.querySelector<HTMLElement>('[data-tk-carousel-next]');
        const pagination = this.querySelector<HTMLElement>('[data-tk-carousel-pagination]');
        const rootLightGalleryItem = this.querySelector<HTMLElement>(this.lightGalleryRootSelector);

        if (!root || !prevButton || !nextButton || !pagination) {
            console.error('TKCarousel: Required elements are missing in the DOM.');
            return;
        }

        const defaultOptions: SwiperOptions = {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'tk-carousel__arrow--disabled',
                enabled: false,
            },
            pagination: {
                el: pagination,
                bulletClass: 'tk-carousel__pagination-page',
                bulletActiveClass: 'tk-carousel__pagination-page--active',
                clickable: true,
                enabled: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                    navigation: {
                        enabled: true,
                    },
                    pagination: {
                        enabled: true,
                    },
                },
            },
            on: {
                init: this.onCarouselReady.bind(this),
            },
        };

        const config = deepMerge(defaultOptions, this.customOptions);

        this.slider = new Swiper(root, config);
        rootLightGalleryItem && this.mountLightGallery(rootLightGalleryItem);
    }
}
